import React, {FC} from "react"
import {H2, H4, Label} from "@irati/ui/src/Typography"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import TreatsTriggerModal from "@irati-web/wallet/src/components/TreatsModal/TreatsTriggerModal"
import WalletBallance from "@irati/wallet/apollo/query/Wallet"
import authentication from "@irati/auth"
import {isPaymentRequired} from "@irati/deals/helpers/redemption/deal"
import {Deal} from "@irati/types"

import {AvailableBalance} from "./styled/StyledSection"

interface Props {
  deal: Deal
}

const TTDealType: FC<Props> = ({deal}) => {
  if (!deal.isTTDeal || !isPaymentRequired(deal)) {
    return null
  }
  const userId = authentication.user().uuid

  return (
    <WalletBallance variables={{userId, currency: "TT"}}>
      {({data}) => {
        const wallet = data!.wallet

        return (
          <Flex direction="column" alignItems="center" marginBottom={2}>
            <H4 marginBottom={2}>
              <FormattedMessage id="perks.TTDeal.yourPerkboxWallet" />
            </H4>
            <AvailableBalance>
              <Label>
                <FormattedMessage id="perks.TTDeal.available" />
              </Label>
              <Flex>
                <H2>
                  <FormattedCurrency value={wallet.availableBalance} isCents={false} currency={wallet.currency} />
                </H2>
                <TreatsTriggerModal />
              </Flex>
            </AvailableBalance>
          </Flex>
        )
      }}
    </WalletBallance>
  )
}

export default TTDealType
